export const SEARCH_LAYOUTS = ['minimal', 'compact', 'detailed'] as const
export type SearchLayout = (typeof SEARCH_LAYOUTS)[number]

export const SEARCH_LAYOUT_STORAGE_KEY = 'minimany:search-layout:v2'
const LEGACY_SEARCH_LAYOUT_STORAGE_KEY = 'minimany:search-layout:v1'

type LayoutStorage = Pick<Storage, 'getItem' | 'setItem'>

function availableStorage(): LayoutStorage | null {
  if (typeof localStorage === 'undefined') return null
  return localStorage
}

export function isSearchLayout(value: unknown): value is SearchLayout {
  return SEARCH_LAYOUTS.some((layout) => layout === value)
}

export function readSearchLayout(storage = availableStorage()): SearchLayout {
  if (!storage) return 'compact'
  try {
    const value = storage.getItem(SEARCH_LAYOUT_STORAGE_KEY)
    if (isSearchLayout(value)) return value
    const legacyValue = storage.getItem(LEGACY_SEARCH_LAYOUT_STORAGE_KEY)
    if (legacyValue === 'list') return 'detailed'
    if (legacyValue === 'masonry') return 'compact'
    return 'compact'
  } catch {
    return 'compact'
  }
}

export function writeSearchLayout(layout: SearchLayout, storage = availableStorage()): void {
  if (!storage) return
  try {
    storage.setItem(SEARCH_LAYOUT_STORAGE_KEY, layout)
  } catch {
    // The in-memory selection remains usable when browser storage is unavailable.
  }
}
